import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';
import MuiTypography from '@mui/material/Typography';

const Root = styled(MuiBox) `
  flex: 1;
`;
const _EmptyState = styled(MuiBox) `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme }) => theme.palette.N50.main};
`;
const TableEmptyState = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (jsx(Root
    // @ts-ignore
    , Object.assign({ 
        // @ts-ignore
        component: "div" }, rest, { children: jsx(_EmptyState, Object.assign({ "data-testid": "empty-state" }, { children: jsx(MuiTypography, Object.assign({ variant: "h2" }, { children: children })) })) })));
};

export { TableEmptyState as default };
//# sourceMappingURL=TableEmptyState.js.map
